/* eslint-disable no-console */

// ECommerceAdmin (staging): the PWA service worker cached the app and kept serving
// STALE builds after each deploy (old API tokens, 404s). For an actively-iterated
// admin tool that is worse than useless — so instead of registering, we unregister
// any existing worker and clear its caches so the admin always loads the latest deploy.
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations()
    .then(regs => regs.forEach(r => r.unregister()))
    .catch(() => {})
  if (window.caches && caches.keys) {
    caches.keys().then(keys => keys.forEach(k => caches.delete(k))).catch(() => {})
  }
}
